import {Formik} from 'formik'
import {FC} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import { RESPONSE_CODE_SUCCESS } from '../../../../app/modules/category-personnel/const/PersonnelConst'
import { changeUserPassword } from '../../../../app/modules/users/services/userService'
import { TextFieldCustom } from '../../../../app/modules/category-personnel/components/text-field-custom/TextFieldCustom'
import * as Yup from 'yup'
interface Iprops {
    handleClose: () => void    
  }



const AccountSettingDialog: FC<Iprops> = (props) => {
const {handleClose} = props
  const intl = useIntl()
  const initialValues = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
  }
 
  return (
    <>
        <Modal show={true} centered  size={'lg'}  onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title className='text-pri '>
            Thay đổi mật khẩu
            </Modal.Title>
            </Modal.Header>
            <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({    
                oldPassword: Yup.string().required(intl.formatMessage({id: 'VALIDATION.REQUIRE'})),
                newPassword: Yup.string().required(intl.formatMessage({id: 'VALIDATION.REQUIRE'})).min(8,"Mật khẩu tối thiểu 8 kí tự").matches(/[A-Z]/, 'Mật khẩu phải chứa ít nhất một chữ in hoa').matches(/[0-9]/, 'Mật khẩu phải chứa ít nhất một chữ số').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Mật khẩu phải chứa ít nhất một kí tự đặc biệt'),
                confirmNewPassword: Yup.string().required(intl.formatMessage({id: 'VALIDATION.REQUIRE'})) .oneOf([Yup.ref('newPassword'), null], 'Mật khẩu không khớp'),
              })}
          onSubmit={async (values) => {
            const res = await changeUserPassword(values.oldPassword,values.newPassword,values.confirmNewPassword)
            res.data.code === RESPONSE_CODE_SUCCESS
              ? toast.success(intl.formatMessage({id: 'Cập nhật thành công'}))
              : toast.error(res.data.message)
         
            handleClose()
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
            setFieldValue,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Body>
                <Row>
                  <Col xs={12}>
                  <TextFieldCustom
                      name='oldPassword'
                      title='Mật khẩu cũ'
                      type='password'
                      values={values.oldPassword}
                      errors={errors.oldPassword}
                      handleChange={handleChange}
                    />
                  </Col>
                  <Col xs={12}>
                  <TextFieldCustom
                      name='newPassword'
                      title='Mật khẩu mới'
                      type='password'
                      values={values.newPassword}
                      errors={errors.newPassword}
                      handleChange={handleChange}
                    />
                  </Col>
                  <Col xs={12}>
                  <TextFieldCustom
                      name='confirmNewPassword'
                      title='Nhập lại mật khẩu mới'
                      type='password'
                      values={values.confirmNewPassword}
                      errors={errors.confirmNewPassword}
                      handleChange={handleChange}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button type='submit' className=' btn-outline-primary btn-active-light-primary'>
                Xác nhận
                </Button>
                <Button
                  className='btn btn-outline btn-outline-primary btn-active-light-primary'
                  onClick={handleClose}
                >
                  {intl.formatMessage({id: 'DIALOG.ACTION.CLOSE'})}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}
export {AccountSettingDialog}
